import { render } from "./ImageAuth.vue?vue&type=template&id=71222e37&scoped=true"
import script from "./ImageAuth.vue?vue&type=script&lang=js"
export * from "./ImageAuth.vue?vue&type=script&lang=js"

import "./ImageAuth.vue?vue&type=style&index=0&id=71222e37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71222e37"]])

export default __exports__